<!--
@Author: DKing
@Desc: 产品服务-灵活用功系统pc
@Date: 2021-04-22
-->
<template>
  <div>
    <div class="banner-box">
      <div class="min-width-pc">
        <div class="text-box">
          <p class="title">慧用工灵活用工系统</p>
          <p class="text">
            企业级免费灵活用工SaaS系统 <br>
          帮助企业实现任务发布、在线签约、智能审核、薪酬结算，<br>灵工管理等职能服务
          </p>
        </div>
        <img class="banner-img" src="./../../../static/pc/产品服务/banner_product_12.png" alt="">
      </div>
    </div>

    <div class="min-width-pc">
      <div class="title-txt">产品优势</div>

      <div class="product-container">
        <!-- 发布任务 -->
        <div class="item">
          <div class="product-text">
            <p class="title">发布任务</p>
            <p class="text">
              任务针对企业的业务场景，为企业提供标准化模版，帮助企业快速完成任务发布，并通过大数据分析精准匹配给平台上注册的自由职业者，同时完成在线签约
            </p>
          </div>
          <img class="product-img" src="./../../../static/pc/产品服务/img_product_renwufabu@2x.png" alt="">
        </div>

        <!-- 智能审核 -->
        <div class="item">
          <img class="product-img" src="./../../../static/pc/产品服务/img_product_zhinengshenhe@2x.png" alt="">

          <div class="product-text">
            <p class="title">智能审核</p>
            <p class="text">
              自由职业者完成企业发布的任务后，平台会根据企业设定的审核标准在线智能审核      
            </p>
          </div>
        </div>

        <!-- 薪酬结算 -->
        <div class="item">
          <div class="product-text">
            <p class="title">薪酬结算</p>
            <p class="text">
              高效导入：企业可批量上传任务服务费结算单 <br>
              秒级到账：实时对接银行系统，支持7*24小时结算下发，可下发至自由职业者个人银行账户、微信钱包账户、支付宝账户<br>
              专管账户：招商、网商银行专管账户，只能按企业命令进行下发，资金无挪用风险。
            </p>
          </div>
          <img class="product-img" src="./../../../static/pc/产品服务/img_product_xinchoujiesuan.png" alt="">
        </div>

        <!-- 开放接口 -->
        <div class="item">
          <img class="product-img" src="./../../../static/pc/产品服务/img_product_kaifangjiekou@2x.png" alt="">

          <div class="product-text">
            <p class="title">开放接口</p>
            <p class="text">
              慧用工为企业提供API接口，为企业赋能，让企业能够将慧用工的服务融入自己的平台体系。
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗form -->
    <pc-form-dialog :source='source'><span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span></pc-form-dialog>
    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>
  </div>
</template>

<script type="text/javascript">
import pcFormDialog from '../../components/pcFormDialog.vue'
import pcSuspensionDialog from "../../components/pcSuspensionDialog";

export default {
  data() {
    return {
      source: '',
      sourceF: ''
    }
  },

  components: {
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=cpfw_lhyg' : '&pageFrom=cpfw_lhyg';
    this.sourceF = this.source + "_f";
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.banner-box{
  background:url('./../../../static/pc/产品服务/banner_product_11.png');
  background-size: contain;
  background-color: #1b6ef1;
  .min-width-pc{
    flex-direction: row;
    align-items: center;
  }
}
.title-txt{
  margin-top:88px;
}
.product-container{
  margin-top: 96px;
  .item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 80px;
    .product-text{
      width:495px;
      text-align: left;
      .title{
        color: rgba(64, 63, 63, 100);
        font-size: 24px;
        // font-family: AlibabaPuHuiTi-Medium;
        margin-bottom: 20px;
        font-weight: bold;
      }
      .text{
        line-height: 36px;
        color: rgba(64, 63, 63, 100);
        font-size: 16px;
      }
    }

    .product-img{
      width: 480px;
      height: 320px;
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/prodServ_pc.vue